import React, { useState } from 'react';
import { Popover } from 'react-tiny-popover';
import { PopoverErrorBoundary } from '@/components/ErrorBoundaries/PopoverErrorBoundary';

interface SummaryPopoverProps {
  children: React.ReactNode;
  summary: string | null;
  className?: string;
  disabled?: boolean;
}

export function SummaryPopover({ 
  children, 
  summary,
  className = '',
  disabled = false
}: SummaryPopoverProps) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  // If disabled, just render children without popover functionality
  if (disabled) {
    return <div className={className}>{children}</div>;
  }

  return (
    <PopoverErrorBoundary>
      <Popover
        isOpen={isPopoverOpen}
        positions={['top']}
        align="center"
        padding={0}
        reposition={false}
        containerStyle={{ 
          zIndex: '100',
          marginLeft: '2rem'
        }}
        content={
          <div 
            className="bg-white p-3 rounded-md shadow-lg border border-gray-200 max-w-md"
            style={{
              width: '100%'
            }}
            onMouseEnter={() => setIsPopoverOpen(true)}
            onMouseLeave={() => setIsPopoverOpen(false)}
          >
            <p className="text-sm text-gray-700 line-clamp-3">
              <span className="rainbow-wave font-medium">[Summary]</span>{' '}
              {summary || 'No summary available'}
            </p>
          </div>
        }
      >
        <div 
          className={className}
          onMouseEnter={() => setIsPopoverOpen(true)}
          onMouseLeave={() => setIsPopoverOpen(false)}
        >
          {children}
        </div>
      </Popover>
    </PopoverErrorBoundary>
  );
} 